export default __webpack_public_path__ + "static/media/blog-paver-walkway-004.bedb3a79.jpg";